<template>
    <v-dialog
        v-model="dialog"
        :fullscreen="$vuetify.display.mobile"
        height="90vh"
    >
        <v-card>
            <template v-if="url">
                <v-img
                    v-if="media.content_type?.startsWith('image/') ?? false"
                    :src="url"
                    height="100%"
                    max-height="100%"
                    max-width="100%"
                    width="100%"
                />
                <video
                    v-else-if="media.content_type?.startsWith('video/') ?? false"
                    controls
                >
                    <source
                        :src="url"
                        :type="media.content_type"
                    />
                </video>
                <object
                    v-else-if="media.content_type === 'application/pdf' && !$vuetify.display.mobile"
                    :key="url"
                    :data="url"
                    :type="media.content_type"
                />
                <iframe
                    v-else-if="media.content_type === 'application/pdf'"
                    :src="url"
                ></iframe>
                <iframe
                    v-else
                    ref="iframe"
                    :src="url"
                    sandbox
                />
            </template>
            <Loader v-else />
            <v-btn
                @click="dialog = false"
                class="mb-12"
                icon="mdi-close"
                location="bottom"
                position="absolute"
                size="x-large"
                color="secondary"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Loader from '@old/components/Loader.vue'
import { api_mixin } from '@old/mixins/api_mixin'

export default {
    name: 'MediaDialog',
    props: {},
    mixins: [api_mixin],
    components: { Loader },
    data() {
        return {
            dialog: false,
            url: '',
        }
    },
    computed: {
        ...mapState(['media']),
    },
    watch: {
        media(value) {
            if (Object.keys(value).length) {
                this.dialog = true
                this.get_url()
            }
        },
        dialog(value) {
            if (!value) {
                this.set_state_property({
                    property: 'media',
                    data: {},
                })
            }
        },
    },
    methods: {
        async get_url() {
            const { resource, document_id, bucket_id } = this.media
            const url = `/media--url/${resource}/${document_id}/${bucket_id}`
            const response = await this.api_get({
                url: url,
            })
            if (response.status === 200) {
                this.url = response.data.url
            }
        },
        ...mapActions(['set_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
    unmounted() {},
}
</script>

<style scoped lang="scss">
iframe,
video,
object,
iframe {
    width: 100%;
    height: 100%;
    max-width: 100%;
    object-fit: contain;
    border: none;
}
</style>
